import { useQuery } from "@tanstack/react-query";
import { getTotalTVL } from "@services/index";
import { useIdle } from "react-use";

const useTotalTVL = () => {
  const isIdle = useIdle(150e3);

  // const { data: tvlStats, isLoading } = useQuery({
  //   queryKey: ["tvlStats"],
  //   queryFn: async () => {
  //     const r = await getTVL();
  //     return r.data;
  //   },
  // });

  // const { data: gainTvl, isLoading: isLoadingGainTvl } = useQuery({
  //   queryKey: ["gainTvl"],
  //   queryFn: async () => {
  //     const r = await getGainTVL();
  //     return r.data;
  //   },
  // });

  // const stakedAmount = useMemo(() => {
  //   let amount = 0;
  //   if (tvlStats?.usdTvl) {
  //     amount += tvlStats.usdTvl;
  //   }
  //   if (gainTvl) {
  //     amount += gainTvl.tvl;
  //   }
  //   return amount;
  // }, [tvlStats, gainTvl]);

  const { data: totalTvl, isLoading } = useQuery({
    queryKey: ["totalTvl"],
    queryFn: async () => {
      const r = await getTotalTVL();
      return r.data;
    },
    enabled: !isIdle,
    staleTime: 30 * 1000, // 30 seconds - TVL doesn't change that rapidly
    refetchInterval: 30 * 1000, // Refetch every 30 seconds instead of 20 seconds
    placeholderData: (previousData) => previousData, // Keep old data while refetching for smooth UX
    refetchIntervalInBackground: false, // Don't refetch when tab is hidden
  });

  return {
    isLoadingTotalTvl: isLoading,
    totalStaked: totalTvl?.tvl,
  };
};

export default useTotalTVL;
